<app-loader [loading]="isLoading" [fullPage]="true" [title]="'chargement'"></app-loader>
<section *ngIf="!isLoading" class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>

    <section class="appointment grid-12 no-gutter appointment-confirmation-page">
        <div class="simulation__group">
            <div autoscroll="false">
                <div class="appointment-confirmation__header grid-container">
                    <div class="grid-12 appointment-confirmation__header--desktop-padding">
                        <div class="grid-8 grid-mobile-4">
                            <div class="appointment-confirmation__header-checked grid-2 grid-mobile-4">
                                <img alt="" [appAssetSrc]="'assets/images/check-circle-green-o.svg'" />
                            </div>
                            <div class="appointment-confirmation__header-container grid-10 grid-mobile-4">
                                <div class="appointment-confirmation__header-container-title">
                                    {{ 'appointment.appointmentconfirmation.title' | i18n }}
                                </div>
                                <div class="appointment-confirmation__header-container-datetitle">
                                    <span>{{ appointment.labelDate }}</span>
                                </div>
                                <div class="gutter-top ng-binding">
                                    {{ 'appointment.appointmentconfirmation.details' | i18n }}
                                </div>
                            </div>
                        </div>
                        <div class="grid-4 grid-mobile-4 download-block--button gutter-top gutter-bottom">
                            <button
                                type="button"
                                class="button--download float-right"
                                data-tag-commander=""
                                [appTagCommander]="'tagCo.appointment.appointmentconfirmation.addtocalendar.button'"
                                (click)="addAppointmentToCalendar()"
                                download="event.ics"
                            >
                                <div class="appointment-confirmation__header-diaryText ng-binding">
                                    <em class="appointment-confirmation__header-dateInput"></em>
                                    {{ 'appointment.appointmentconfirmation.buttons.diary' | i18n }}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="appointment-confirmation__box">
                    <div class="grid-container">
                        <div class="grid-6 grid-mobile-4">
                            <div class="appointment-confirmation__box-body appointment-confirmation__box-body--primary">
                                {{ 'appointment.appointmentconfirmation.exam.text' | i18n }}
                            </div>
                            <div class="appointment-confirmation__box-body--documents">
                                <div class="gutter-bottom ng-binding">
                                    {{ 'appointment.appointmentconfirmation.exam.result.info.cofrac' | i18n }}
                                </div>
                                <div *ngFor="let doc of documentList" class="appointment-confirmation__box-body--documents__document">
                                    {{ doc.label }}
                                </div>
                            </div>
                            <div class="appointment-confirmation__box-body appointment-confirmation__box-body--secondary">
                                {{ 'appointment.appointmentconfirmation.exam.orders.title' | i18n }}
                            </div>
                            <div *ngIf="isDocumentListContainBilanSanguin()" class="appointment-confirmation__box-body--documentsOrder">{{ 'appointment.appointmentconfirmation.exam.orders.firstdescription' | i18n }}<br /></div>
                            <div class="appointment-confirmation__box-body--documentsOrder">
                                {{ 'appointment.appointmentconfirmation.exam.orders.idc' | i18n }}
                            </div>
                            <div class="appointment-confirmation__box-body--documentsOrder">
                                {{ 'appointment.appointmentconfirmation.exam.orders.seconddescription' | i18n }}
                            </div>
                            <button
                                (click)="downloadFile()"
                                type="button"
                                class="button button--grey button--previous appointment-confirmation__box-body__download-button ng-pristine ng-untouched ng-valid ng-isolate-scope"
                                data-tag-commander=""
                                [appTagCommander]="'tagCo.appointment.appointmentconfirmation.pij.button'"
                            >
                                <span data-ng-transclude="">
                                    <em class="icon icon--arrow-down-border"></em>
                                    <span class="button-text">{{ 'documentselection.documents.button.text' | i18n }}</span>
                                </span>
                            </button>
                            <div class="appointment-confirmation__box-body--documentsOrder">
                                <em>{{ 'appointment.appointmentconfirmation.email.confirm' | i18n }}</em>
                            </div>
                        </div>
                        <div class="grid-6 grid-mobile-4 appointment-confirmation__box-body appointment-confirmation__box-mapSide">
                            <div class="appointment-confirmation__box-body appointment-confirmation__box-mapSide--address">{{ appointment.praticien.libelle }} - {{ appointment.praticien.libelleCentre }}&nbsp;:</div>
                            <div class="appointment-confirmation__box-body--documents appointment-confirmation__box-mapSide--address-details">
                                {{ appointment.praticien.adresse1 }},&nbsp;{{ appointment.praticien.codePostal }}&nbsp;{{ appointment.praticien.ville }}
                            </div>
                            <google-map [center]="coordinatesPraticien" [zoom]="13" [width]="null" [height]="265" *ngIf="geolocApiLoaded">
                                <map-marker [position]="coordinatesPraticien" [icon]="iconUrlPraticien"></map-marker>
                                <div class="map-legend">
                                    <div class="map-legend__label"><span class="map-legend__icon green"></span>RDV en ligne</div>
                                    <div class="map-legend__label"><span class="map-legend__icon pink"></span>RDV par téléphone</div>
                                </div>
                            </google-map>
                        </div>
                    </div>
                </div>
                <div class="simulation__buttons simulation__buttons--light appointment-confirmation__footer--buttons">
                    <div class="grid-9 grid-mobile-4 no-gutter-mobile appointment-confirmation__footer--buttons-style">
                        <button
                            type="button"
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.appointment.appointmentconfirmation.modifyappointment.button'"
                            class="button button--grey button--previous grid-mobile-4"
                            (click)="goToEditRdvMedical()"
                        >
                            {{ 'appointment.appointmentconfirmation.button.move-appointment' | i18n }}
                        </button>
                        <button
                            type="button"
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.appointment.appointmentconfirmation.cancelappointment.button'"
                            class="appointment-confirmation__footer--cancelRdv button button--primary button--next"
                            (click)="showAppointmentCancelModal = true"
                        >
                            {{ 'appointment.appointmentconfirmation.cancel.text' | i18n }}
                        </button>
                    </div>

                    <div class="grid-3 grid-mobile-4 no-gutter">
                        <button type="button" class="button button--primary button--next float-right grid-mobile-4" routerLink="/souscription/document-medicale/document-list">
                            {{ 'appointment.apppointmentconsent.buttons.next' | i18n }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
<app-validation-modal-component
    [visibility]="showAppointmentCancelModal"
    [modalTitle]="'appointment.appointmentconfirmation.popin.confirmation.title'"
    [content]="'appointment.appointmentconfirmation.popin.confirmation.label'"
    [buttonLeft]="'global.button.back'"
    [buttonRight]="'global.yescancel'"
    [specificIconBlock]="'modal-info-red'"
    (crossClick)="showAppointmentCancelModal = false"
    (leftClick)="showAppointmentCancelModal = false"
    (rightClick)="deleteAppointment()"
>
</app-validation-modal-component>
